module.exports = __webpack_public_path__ + "static/media/same.61b45f58.svg";